const propertyOverrideType = {
    nmmId: "NmmId",
    tags: "Tags",
    domainIds: "DomainIds",
}

export default propertyOverrideType;